/* ============================================================
   กลุ่มปุ่มบนหัวหน้าเอกสาร ใช้รูปแบบเดียวกันทุกระบบ

   [ 🖨 พิมพ์ | ปุ่มพิมพ์ ... ]  [ ดำเนินการ | ปุ่มทำงาน ... ]  [ Save ]

   <ActionGroup type="print">
     <PrintButton onClick={...}>ห้องสารส่วนผสม</PrintButton>
   </ActionGroup>
   <ActionGroup type="action">
     <Button ...>สร้างใบเบิก</Button>
   </ActionGroup>

   - type="print"  : กรอบเส้นประสีเทา ปุ่มพื้นขาว
   - type="action" : กรอบสีฟ้าอ่อน ปุ่มสีทึบตามงาน
   - ไม่มีปุ่มข้างใน (ทุกปุ่มถูกซ่อนตามสิทธิ์/สถานะ) จะไม่แสดงกรอบ
============================================================ */
import React from "react";
import { Button, Flex, Typography } from "antd";
import { PrinterOutlined } from "@ant-design/icons";

export const ACTION_BTN = { minWidth: "9.5rem", height: 36, paddingInline: 12 };

const BOX = { padding: "4px 8px", borderRadius: 8 };
const STYLE = {
  print: { ...BOX, border: "1px dashed #d9d9d9", background: "#fafafa" },
  action: { ...BOX, border: "1px solid #d6e4ff", background: "#f0f5ff" },
};
const LABEL = { fontSize: 12, whiteSpace: "nowrap", marginInline: 4 };

export default function ActionGroup({ type = "action", label, children }) {
  const items = React.Children.toArray(children).filter(Boolean);
  if (items.length === 0) return null;

  return (
    <Flex gap={6} align="center" wrap="wrap" style={STYLE[type] || STYLE.action}>
      <Typography.Text type="secondary" style={LABEL}>
        {type === "print" ? (
          <>
            <PrinterOutlined /> {label || "พิมพ์"}
          </>
        ) : (
          label || "ดำเนินการ"
        )}
      </Typography.Text>
      {items}
    </Flex>
  );
}

/* ปุ่มพิมพ์ : พื้นขาว ขอบเทา ไอคอนเครื่องพิมพ์ */
export function PrintButton({ style, icon, ...rest }) {
  return (
    <Button
      className="bn-center justify-center"
      icon={icon || <PrinterOutlined style={{ fontSize: "1rem" }} />}
      style={{ ...ACTION_BTN, background: "#fff", borderColor: "#d9d9d9", color: "#434343", ...style }}
      {...rest}
    />
  );
}
